const enJSON = {
  'Templates request has failed': 'Templates request has failed', // /content/Templates/index.
  'Template Library': 'Template Library', // /content/Templates/index.
  'Graphics request has failed': 'Graphics request has failed', // /content/Graphics/index.
  'My graphics': 'My graphics', // /content/Graphics/index.
  'Go to templates list': 'Go to templates list', // /content/Graphics/index.
  Copy: 'Copy', // /content/Graphics/_component/Graphic.
  Edit: 'Edit', // /content/Graphics/_component/Graphic.
  Delete: 'Delete', // /content/Graphics/_component/Graphic.
  'View templates list': 'View templates list', // /content/Overview/Hero/index.
  'Preview image': 'Preview image', // /content/Editor/_component/EditorForm/EditorForm.
  'Guud Creative Studio': 'Guud Creative Studio', // /component/Logo/index.
  'Image editor': 'Image editor', // /component/EditImageModal/index.
  'Use this dialog window to edit a image':
    'Use this dialog window to edit a image', // /component/EditImageModal/index.
  Cancel: 'Cancel', // /component/EditImageModal/index.
  'Save image': 'Save image', // /component/EditImageModal/index.
  Version: 'Version', // /component/Logo/index.
  'Edit this image': 'Edit this image', // /component/UploadImageField/index.
  'Remove this image': 'Remove this image', // /component/UploadImageField/index.
  'Choose a file or drag it here': 'Choose a file or drag it here', // /component/UploadImageField/index.
  'Editor form': 'Editor form', // /component/Editor/Templates/TemplateResizer.
  'Graphic has been successfully': 'Graphic has been successfully', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to graphics selection': 'Go to graphics selection', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to template selection': 'Go to template selection', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Text is too long': 'Text is too long', // /layout/CreativeStudioLayout/EditorHeader/index.
  Download: 'Download', // /layout/CreativeStudioLayout/EditorHeader/index.
  Save: 'Save', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Language Switcher': 'Language Switcher', // /layout/CreativeStudioLayout/Header/Buttons/LanguageSwitcher/index.
  Profile: 'Profile', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Inbox: 'Inbox', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Project: 'Project', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign out': 'Sign out', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Template tags': 'Template tags',
  'Select tags...': 'Select tags...',
  Search: 'Search',
  'No templates are available. Contact Guud.tv':
    'No templates are available. Contact Guud.tv',
  //Graphics view
  'Start creating amazing graphics': 'Start creating amazing graphics',
  'Search by name': 'Search by name',
  //Settings view
  Settings: 'Settings',
  Colors: 'Colors',
  "You don't have colors yet, start creating them":
    "You don't have colors yet, start creating them",
  'Create color': 'Create color',
  // Brandkit view
  'Add color': 'Add color',
  'Color name': 'Color name',
  'My logotypes': 'My logotypes',
  'My logotype description':
    'Add brand logos and custom images to use across your templates.',
  'My colors': 'My colors',
  // Account / Payment view
  Trial: 'Trial',
  'Upgrade now': 'Upgrade now',
  Upgrade: 'Upgrade',
  // Account / Payment view / Trial
  ' days left': ' days left',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  Popular: 'Popular',
  Starter: 'Starter',
  'During the trial, you can enjoy all the features without limits. Subscribe after the trial to keep your data and continue using Creative Studio.':
    'During the trial, you can enjoy all the features without limits. Subscribe after the trial to keep your data and continue using Creative Studio.',
  // Account / Payment view / Cancelled Plan Info
  Cancelled: 'Cancelled',
  'Upps! Your subscription has been cancelled. Subscribe to keep your data and continue using Creative Studio.':
    'Upps! Your subscription has been cancelled. Subscribe to keep your data and continue using Creative Studio.',
  // Account / Payment view / Inactive Plan Info
  Inactive: 'Inactive',
  'Upps! Your trial period is over. Subscribe to keep your data and continue using Creative Studio.':
    'Upps! Your trial period is over. Subscribe to keep your data and continue using Creative Studio.',
  // Account / Payment view / Past Due Plan Info
  "We've encountered a hiccup while processing the payment with the card on file.":
    "We've encountered a hiccup while processing the payment with the card on file.",
  "No worries, these things happen for various reasons, and we're here to help you get it sorted.":
    "No worries, these things happen for various reasons, and we're here to help you get it sorted.",
  'Could you please take a moment to update your payment information?':
    'Could you please take a moment to update your payment information?',
  'If you need any further assistance or have any questions, feel free to reach out to us.':
    'If you need any further assistance or have any questions, feel free to reach out to us.',
  'Get in touch with us to update': 'Get in touch with us to update',
  'your payment information.': 'your payment information.',
  // Account / Payment view / Active Plan Info
  'Switch to yearly (Save 20%)': 'Switch to yearly (Save 20%)',
  'Switch to monthly': 'Switch to monthly',
  Price: 'Price',
  Billing: 'Billing',
  'Start date': 'Start date',
  'Renewal date': 'Renewal date',
  'Subscription cancelled': 'Subscription cancelled',
  // Account / Payment view / Update subscription
  'Update subscription': 'Update subscription',
  'Are you sure you want to update your Creative Studio subscription to ':
    'Are you sure you want to update your Creative Studio subscription to ',
  'yearly?': 'yearly?',
  'monthly?': 'monthly',
  // Account / Payment view / Delete subscription
  'Are you sure you want to cancel your Creative Studio subscription?':
    'Are you sure you want to cancel your Creative Studio subscription?',
  'Cancel subscription': 'Cancel subscription',
  'Delete subscription': 'Delete subscription',
  // Account / Trial period alert
  Only: 'Only',
  "day left trial period. Let's continue creating together! ":
    "day left trial period. Let's continue creating together! ",
  'We are sad that your time with us has ended... for now!':
    'We are sad that your time with us has ended... for now!'
};
export default enJSON;
